import classnames from 'classnames';

import {RecurrenceMode} from 'nutshell-graphql-types';

import {MONTH_UNIT, WEEK_UNIT} from './consts';
import type {
    RecurrenceDueDateFormSetters,
    RecurrenceDueDateFormState,
} from './recurrence-due-date-mode-form-types';
import {RecurrenceFrequencySegmentedControl} from './recurrence-frequency-segmented-control';
import {RecurrenceMonthlyOnRow} from './recurrence-monthly-on-row';
import {RecurrenceRepeatEveryRow} from './recurrence-repeat-every-row';
import {RecurrenceWeeklyWeekdayPicker} from './recurrence-weekly-weekday-picker';

import styles from './task-custom-recurrence-popover.module.css';

export type {RecurrenceDueDateFormSetters, RecurrenceDueDateFormState};

interface Props {
    mode: RecurrenceMode;
    values: RecurrenceDueDateFormState;
    setters: RecurrenceDueDateFormSetters;
    /**
     * When true, the frequency is chosen via a Daily/Weekly/Monthly segmented
     * control (interval always 1) instead of the "Repeat every X" input. Used
     * by surfaces that don't expose the interval concept (e.g. scheduled report
     * exports).
     */
    useFrequencySegmentedControl?: boolean;
}

export function RecurrenceDueDateModeForm(props: Props) {
    const isDisabled = props.mode !== RecurrenceMode.DUE_DATE;

    return (
        <div
            className={classnames(styles['radio-option-fields'], {
                [styles['radio-option-fields--no-indent']]: props.useFrequencySegmentedControl,
            })}
        >
            {props.useFrequencySegmentedControl ? (
                <RecurrenceFrequencySegmentedControl
                    values={props.values}
                    setters={props.setters}
                />
            ) : (
                <RecurrenceRepeatEveryRow
                    values={props.values}
                    setters={props.setters}
                    isDisabled={isDisabled}
                />
            )}
            {props.values.cycleUnit === MONTH_UNIT && (
                <RecurrenceMonthlyOnRow
                    values={props.values}
                    setters={props.setters}
                    isDisabled={isDisabled}
                />
            )}
            {props.values.cycleUnit === WEEK_UNIT && (
                <RecurrenceWeeklyWeekdayPicker
                    values={props.values}
                    setters={props.setters}
                    isDisabled={isDisabled}
                />
            )}
        </div>
    );
}
